var SpriteSymbol = require("../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "calendar",
  "use": "calendar-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"calendar\">\r\n  <path d=\"M6.26667 7.3H4.84444V8.7H6.26667V7.3ZM9.11111 7.3H7.68889V8.7H9.11111V7.3ZM11.9556 7.3H10.5333V8.7H11.9556V7.3ZM13.3778 2.4H12.6667V1H11.2444V2.4H5.55556V1H4.13333V2.4H3.42222C2.63289 2.4 2.00711 3.03 2.00711 3.8L2 13.6C2 14.37 2.63289 15 3.42222 15H13.3778C14.16 15 14.8 14.37 14.8 13.6V3.8C14.8 3.03 14.16 2.4 13.3778 2.4ZM13.3778 13.6H3.42222V5.9H13.3778V13.6Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol